import React from "react";

import facebook from "../assets/icons/facebook.svg";
import github from "../assets/icons/github.svg";
import twitter from "../assets/icons/twitter.png";
import pin from "../assets/icons/pin.svg";
import tie from "../assets/icons/tie.svg";
import mightycoder from "../assets/mightycoder.svg";
import resume from "../assets/resume.pdf"

const Sidebar = () => {

  const handleEmail = ()=>{
    window.open("mailto:faythkoko98@gmail.com");
  }

  return (
    <div className="sidebar">
      <img src={mightycoder} alt="avatar" className="sidebar__avatar" />
      <div className="sidebar__name">
        Faith <span>Chepkorir</span>
      </div>
      <div className="sidebar__item sidebar__title">Machine Learning Analyst </div>
      <a href={resume} download="resume.pdf">
        <div className="sidebar__item sidebar__resume">
          <img src={tie} alt="resume" className="sidebar__icon" /> Download
          Resume
        </div>
      </a>
      <figure className="sidebar__social-icons my-2">
        <a href="https://www.facebook.com/noeller.chepkorir">
          <img src={facebook} className="sidebar__icon mr-3" alt="facebook" />
        </a>
        <a href="https://twitter.com/koko23737961">
          <img src={twitter} className="sidebar__icon" alt={"twitter"} />
        </a>
      </figure>
      <div className="sidebar__contact">
        <div className="sidebar__item sidebar__github">
          <a href="https://github.com/chrpkorir">
            <img src={github} alt="" className="sidebar__icon mr-2" />
            github
          </a>
        </div>
        <div className="sidebar__location">
          <img src={pin} alt="location" className="sidebar__icon mr-2" />
          Sotik Kenya
        </div>
        <div className="sidebr__item my-3">faythkoko98@gmail.com</div>
        <div className="sidebr__item">+254748831219</div>
      </div>
      <div onClick={handleEmail} className="sidebar__item sidebar__email">email me</div>
    </div>
  );
};

export default Sidebar;
